isExecutionPatchInitialResult